import type { PlayerId, UnitKind } from "@dailywars/core/engine";

import { getUnitShadowImageSrc } from "#/game/svgAssets";
import { getSpriteUnitIconSrc } from "#/game/unitSprites";
import { cn } from "#/lib/utils";

export function UnitIconLayers({
  kind,
  player,
  owner,
  className,
  imageClassName,
}: {
  kind: UnitKind;
  player?: PlayerId;
  owner?: PlayerId;
  className?: string;
  imageClassName?: string;
}) {
  const resolvedOwner = owner ?? player ?? "p1";
  const bodySrc = getSpriteUnitIconSrc(kind, resolvedOwner);
  const shadowSrc = getUnitShadowImageSrc(kind);
  const imgClassName = cn("size-full", imageClassName);

  if (!shadowSrc) {
    return <img src={bodySrc} alt="" className={cn(imgClassName, className)} aria-hidden />;
  }

  return (
    <div className={cn("relative", className)}>
      <img src={shadowSrc} alt="" className={cn("absolute inset-0", imgClassName)} aria-hidden />
      <img src={bodySrc} alt="" className={cn("relative z-10", imgClassName)} aria-hidden />
    </div>
  );
}
